import React from "react";
import "./ArticleEditSepListItem.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

class ArticleEditSepListItem extends React.Component {
  render() {
    return (
      <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
        <Row>
          <Col style={{ padding: "5px" }}>
            <span>我是分隔線</span>
          </Col>
        </Row>
      </Card.Body>
    );
  }
}

export default ArticleEditSepListItem;
